import { DURUS_SAFI } from '@kurultay/tipler'
import type { Kurulum, SavasDurumu, SavasBirimi, Taraf, TarafKurulumu } from './tipler.js'

function tarafiKur(taraf: Taraf, k: TarafKurulumu): SavasBirimi[] {
  const birimler: SavasBirimi[] = [{
    tur: 'kahraman',
    id: `${taraf}-kahraman`,
    taraf,
    meslek: k.kahraman.meslek,
    durus: k.kahraman.baslangicDurusu,
    saf: DURUS_SAFI[k.kahraman.baslangicDurusu],
    ofke: 0,
    buTurDurusDegisti: false,
    durusCezasiAktif: false,
    can: k.kahraman.can,
    azamiCan: k.kahraman.can,
    saldiri: k.kahraman.saldiri,
    zirh: k.kahraman.zirh,
    ruhDirenci: k.kahraman.ruhDirenci,
    hiz: k.kahraman.hiz,
    kritikSansi: k.kahraman.kritikSansi,
    isabet: k.kahraman.isabet,
    kacinma: k.kahraman.kacinma,
    yasiyor: true,
  }]

  k.ceriler.forEach((c, i) => {
    // Çeri yığını tek bir varlık gibi savaşır; canı adet ile ölçeklenir.
    const toplamCan = c.can * c.adet
    birimler.push({
      tur: 'ceri',
      id: `${taraf}-ceri-${i}`,
      taraf,
      ceriTuru: c.ceriTuru,
      adet: c.adet,
      saf: c.saf,
      can: toplamCan,
      azamiCan: toplamCan,
      saldiri: c.saldiri,
      zirh: c.zirh,
      ruhDirenci: c.ruhDirenci,
      hiz: c.hiz,
      kritikSansi: 0.05,
      isabet: 150,
      kacinma: 30,
      yasiyor: true,
    })
  })

  return birimler
}

export function durumOlustur(kurulum: Kurulum): SavasDurumu {
  return {
    birimler: [...tarafiKur('a', kurulum.a), ...tarafiKur('b', kurulum.b)],
    tur: 1,
    bitti: false,
    kazanan: null,
  }
}
